import { Box }            from '@chakra-ui/react';
import { Button }         from '@/components/ui/button';
import { Input }          from '@chakra-ui/react';
import React              from 'react'
import SearchIcon         from '@/assets/icons/SearchIcon';
import { Text }           from '@chakra-ui/react';
import _uniqueId          from 'lodash/uniqueId';
import { useNavigate }    from 'react-router-dom';
import useSearch          from '@/hooks/useSearch';
import { useTranslation } from 'react-i18next';

const NavBarSearchInput = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { searchInputValue, setSearchInputValue, searchResults } = useSearch();

	const [focused, setFocused] = React.useState(false);
	const onFocus = () => setFocused(true);
	const onBlur = () => setFocused(false);

	return (
		<Box
			display="flex"
			alignItems="center"
			gap="10px"
			hideBelow="lg"
			position="relative"
		>
			<Input
				value={searchInputValue}
				transition="all 0.4s ease-in-out"
				placeholder={t('components.navBar.search')}
				cursor="pointer"
				borderColor="black"
				outlineColor="#707070"
				color="white"
				width="40px"
				paddingRight="45px"
				borderRadius="lg"
				onChange={(event) => setSearchInputValue(event.target.value)}
				onFocus={onFocus}
				onBlur={() => {
					setTimeout(() => {
						setSearchInputValue('');
						onBlur()
					}, 200);
				}}
				_hover={{
					width: "200px",
					borderColor:"#707070"
				}}
				_focus={{
					width: "200px",
					borderColor:"#707070"
				}}
				zIndex={2}
			/>
			<SearchIcon position="absolute" top="6px" right="7px" color="#707070" size="2xl" zIndex={1} />
			{
				focused && searchInputValue.length > 0 &&
				<Box
					bg="white"
					width="300px"
					position="absolute"
					top="45px"
					left="0px"
					rounded="md"
					shadow="md"
					padding="15px"
					display="flex"
					flexDirection="column"
					gap="10px"
					zIndex={3}
				>
					<Text className='poppins-semibold' color="#A7A8A7" fontSize="14px">{t('components.navBar.suggestions').toUpperCase()}</Text>
					<Box
						display="flex"
						alignItems="center"
						flexWrap="wrap"
						gap="5px"
					>
						{
							searchResults?.length === 0 &&
							<Text fontStyle="italic">{t('components.navBar.noResults')}</Text>
						}
						{
							searchResults?.map(result => {
								return <Button
									key={_uniqueId()}
									rounded="full"
									color="black"
									backgroundColor="#00000029"
									fontSize="12px"
									height="30px"
									cursor="pointer"
									zIndex={4}
									onClick={() => navigate(result.item.to)}
									_hover={{ backgroundColor: "#A7A8A7" }}
								>
									<Text className="poppins-regular">{result.item.tagName}</Text>
								</Button>
							})
						}
					</Box>
				</Box>
			}
		</Box>
	);
};

export default NavBarSearchInput;